// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"1818eed8","455":"60b49c6a","977":"a2a119ed"}[chunkId] + ".chunk.js";
};